import { useInfiniteQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getWalletContactInstruments } from 'services/ContactService'
import { BeneficiaryEntityType } from 'types/beneficiaries'
import { ContactPaymentInstrumentsResponse, RelationshipType } from 'types/contacts'

interface WalletContactInstrumentsInfiniteQueryProps {
  walletLsid?: string
  searchTerm?: string
  relationshipType?: RelationshipType
  entityType?: BeneficiaryEntityType
  enabled?: boolean
  size?: number
  isVersion3?: boolean
}

export const useWalletContactInstrumentsInfiniteQuery = ({
  walletLsid,
  searchTerm = '',
  relationshipType,
  entityType,
  enabled = true,
  size = 50,
  isVersion3 = false,
}: WalletContactInstrumentsInfiniteQueryProps) => {
  return useInfiniteQuery({
    enabled,
    queryKey: reactQueryKeys.walletContactPaymentInstruments(
      walletLsid,
      searchTerm,
      relationshipType,
      entityType,
      isVersion3
    ),
    queryFn: ({ pageParam = 0 }): Promise<ContactPaymentInstrumentsResponse> =>
      getWalletContactInstruments({
        walletLsid,
        searchTerm,
        size,
        page: pageParam,
        sort: '',
        relationshipType,
        entityType,
        isVersion3,
      }),
    getNextPageParam: (lastPage: ContactPaymentInstrumentsResponse) => {
      return lastPage?.pageable?.pageNumber + 1 < lastPage?.totalPages
        ? lastPage?.pageable.pageNumber + 1
        : undefined
    },
    initialPageParam: 0,
    select: data => {
      const contactInstruments = data?.pages?.flatMap(page => page?.content)
      return contactInstruments
    },
  })
}
